import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import Input from '@/_application/core/components/ui/forms/input';
import {toastErrorMessage} from '@/_application/core/components/ui/toast/toast';
import {ChangeEvent, useState} from 'react';

function FooterSubscriptionForm() {
    const [email, setEmail] = useState('');

    const handleSubscribeClick = () => {
        if (!email.trim()) {
            toastErrorMessage('Vui lòng nhập địa chỉ email của bạn.');
            return;
        }

        setEmail('');
        toastErrorMessage(
            'Xin lỗi, tính năng này đang được bảo trì. Vui lòng quay lại vào ngày 30/04 để sử dụng tính năng này.',
        );
    };

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    return (
        <div className="lg:mb-0">
            <p className="text-[14px] font-bold uppercase leading-[19px] text-primary">Nhận tin khuyến mãi & quà</p>
            <div className="mt-3 flex items-center">
                <Input
                    variant="outline"
                    placeholder="Nhập địa chỉ email của bạn"
                    className="h-10 w-full"
                    inputClassName="rounded-lg border-none bg-black/10 h-full"
                    name="email-subscription"
                    value={email}
                    onChange={handleInputChange}
                    aria-label="Email đăng kí"
                />
                <Button
                    onClick={handleSubscribeClick}
                    aria-label="Đăng kí"
                    className="ml-3 rounded-lg bg-KPZ_Cam hover:bg-orange-500/90!"
                    size="small">
                    Áp dụng
                </Button>
            </div>
        </div>
    );
}

export default FooterSubscriptionForm;
